import { blue100, blue600, red100 } from 'material-ui/styles/colors';

const styles = {
    questionPreTitle: {
        fontWeight: 500
    },
    paper: {
        borderLeft: blue600 + ' 3px solid',
        margin: '10px 15px',
        padding: '0 15px',
    },
    row: {
        marginRight: '0',
        marginLeft: '0',
    },
    imageContainer: {
        width: '100%',
        height: '100%',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        width: '100%',
        height: 'auto'
    },
    addPictureIcon: {
        height: '30px',
        width: '30px'
    },
    pictureIconsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'absolute',
        bottom: 3,
        right: 'calc(50% - 54px)',
        zIndex: 1,
        width: '102px'
    },
    deleteIcon: {
        backgroundColor: red100,
        borderRadius: '24px'
    },
    editIcon: {
        backgroundColor: blue100,
        borderRadius: '24px'
    },
    responseItem: {
        listStyleType: 'none'
    },
    responseValidDot: {
        color: blue600,
        height: '20px',
        width: '20px',
        verticalAlign: 'bottom',
        paddingRight: '10px'
    },
    responseInvalidDot: {
        height: '20px',
        width: '20px',
        verticalAlign: 'bottom',
        paddingRight: '10px'
    },
    pointMessage: {

    },
    points: {
        color: blue600,
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/quiz/QuestionInfo/QuestionInfo.css.js